import React from 'react';
import { cn } from '../../lib/cn';

const PALETTE = [
  { bg: 'bg-brand-100',   text: 'text-brand-700' },
  { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  { bg: 'bg-amber-100',   text: 'text-amber-700' },
  { bg: 'bg-sky-100',     text: 'text-sky-700' },
  { bg: 'bg-rose-100',    text: 'text-rose-700' },
  { bg: 'bg-violet-100',  text: 'text-violet-700' }
];

function hash(str = '') {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

function initials(name = '') {
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]).filter(Boolean).join('').toUpperCase() || '?';
}

const SIZES = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-[13px]',
  lg: 'h-11 w-11 text-[15px]'
};

export default function Avatar({ name = '', size = 'md', className }) {
  const swatch = PALETTE[hash(name) % PALETTE.length];
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold ring-2 ring-white shadow-soft',
        swatch.bg, swatch.text, SIZES[size],
        className
      )}
    >
      {initials(name)}
    </span>
  );
}
